import { MovementMap } from "../MovementMap";
import { TrackingHistory } from "../asset/TrackingHistory";
import { Button, CityState, DataSource, Image, Label, Layout, Panel, Splitter, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDetentionHistory extends Layout {
    buttonChgDetail: Image;
    buttonPayDetail: Image;
    buttonRecalculate: Button;
    citystateCustomer: CityState;
    citystateStop: CityState;
    imageMoveXferSettlement: Image;
    imageOrderXferBilling: Image;
    imageXferBilling: Image;
    imageXferSettlement: Image;
    labelC: Label;
    labelCustomer: Label;
    labelCustomeraddress1: Label;
    labelDetentionDetails: Label;
    labelNotifications: Label;
    labelPay: Label;
    labelStatus: Label;
    labelStopTimeOffset: Label;
    labelStopTimezone: Label;
    labelStopaddress: Label;
    labelStopcontactEmail: Label;
    labelStoplocationName: Label;
    labelStopphone: Label;
    labelTimeZone: Label;
    layoutMovementMap: MovementMap;
    layoutTrackingHistory: TrackingHistory;
    panelCreation: Panel;
    panelCustomer: Panel;
    panelDetails: Panel;
    panelDetention: Panel;
    panelIDs: Panel;
    panelIdAndWarnings: Panel;
    panelMove: Panel;
    panelMovementId: Panel;
    panelNotifications: Panel;
    panelOrderId: Panel;
    panelOverview: Panel;
    panelPrimary: Panel;
    panelStatus: Panel;
    panelStop: Panel;
    panelTiming: Panel;
    panelWarnings: Panel;
    sourceDetentionHistChg: DataSource;
    sourceDetentionHistPay: DataSource;
    sourceDetentionHistory: DataSource;
    splitterTracking: Splitter;
    switchBillingApproved: Switch;
    tabChargesAndPay: Tab;
    tabDetails: Tab;
    tabMCPositions: Tab;
    tableCharges: Table;
    tablePay: Table;
    tabsetDetentionHist: Tabset;
    tabsetRelated: Tabset;
    textboxActualArrival: Textbox;
    textboxActualDeparture: Textbox;
    textboxAuthorizationNum: Textbox;
    textboxAuthorizationStatus: Textbox;
    textboxChgCustomerId: Textbox;
    textboxCommodityId: Textbox;
    textboxCreationDate: Textbox;
    textboxDetentionDefId: Textbox;
    textboxDetentionTime: Textbox;
    textboxFreeTimeEnd: Textbox;
    textboxFreeTimeStarts: Textbox;
    textboxLoadedTime: Textbox;
    textboxMovementId: Textbox;
    textboxNotifyArrivalDt: Textbox;
    textboxNotifyChargeDt: Textbox;
    textboxNotifyDepartDt: Textbox;
    textboxNotifyWarnDt: Textbox;
    textboxOrderId: Textbox;
    textboxPayApproval: Textbox;
    textboxSchedArrival: Textbox;
    textboxSchedArriveLate: Textbox;
    textboxStatus: Textbox;
    textboxStopType: Textbox;
    textboxStopcontactName: Textbox;
    textboxStoplocationId: Textbox;
}
